import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18a1eb05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "majorContainer" }
const _hoisted_2 = { class: "majorItemContainer" }
const _hoisted_3 = { class: "majorItemTitle" }
const _hoisted_4 = { class: "majorItemMain" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "emptyContainer"
}

import {ref, reactive} from 'vue'
  import {useRoute, useRouter} from "vue-router";
  import {
    getOccMajor,
  } from "@/network/axios";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MatchMajor',
  setup(__props) {

  let router = useRouter();
  let route = useRoute();


  //点击 对应本科专业 获取信息
  let majorArray = ref([]);

  //点击 对应本科专业 获取信息
  let getMatchMajor = () => {
    getOccMajor('/getOccMajor', {
      params: {
        occId: route.params.occId,
      }
    }).then((res) => {
      if (res.data.code == 200) {
        majorArray.value = [];
        majorArray.value = res.data.data;
      }
    })
  };
  getMatchMajor();

  //点击 对应本科专业 里面的专业跳转页面
  let majorNameClick = (majorCode: any) => {
    window.open('/MajorSituation/' + majorCode, '_blank')
  }



return (_ctx: any,_cache: any) => {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(majorArray).length>0)
      ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          class: "majorRow"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(majorArray), (item) => {
              return (_openBlock(), _createBlock(_component_el_col, { span: 11 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_el_link, {
                        onClick: ($event: any) => (_unref(majorNameClick)(item.majorCode)),
                        class: "collegeItemLink"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.majorName), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", null, [
                        _createTextVNode(" 国标代码：" + _toDisplayString(item.majorCode) + " | 专业年限：" + _toDisplayString(item.duration) + " ", 1),
                        (item.bacherlor)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, " | 授予学位："))
                          : _createCommentVNode("", true),
                        _createTextVNode(_toDisplayString(item.bacherlor), 1)
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 256))
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_el_empty, { description: "暂无数据" })
        ]))
  ]))
}
}

})